module.exports = __webpack_public_path__ + "static/img/zhyk.e730bd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhyk.png
// module id = exST
// module chunks = 1